import React from 'react';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import FacetContent from '../../lego/FacetContent';
import { useFacet } from '../../common';
const FacetButton = (props)=>{
    const { rootProps, contentProps } = useFacet(props);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, rootProps, /*#__PURE__*/ React.createElement(FacetContent, contentProps));
};
FacetButton.displayName = 'FacetButton';
export default FacetButton;
